var _path, _path2, _g, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraCardIcon9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7019 8.91016H5.94791C5.1558 8.91016 4.51367 9.55229 4.51367 10.3444V11.4232V15.3912V16.7345C4.51367 17.5266 5.1558 18.1687 5.94791 18.1687H14.7019C15.494 18.1687 16.1362 17.5266 16.1362 16.7345V15.4108V15.3912V11.4232V10.3444C16.1362 9.55229 15.494 8.91016 14.7019 8.91016Z",
    fill: "url(#paint0_linear_1389_9565)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6229 9.06048V7.05254C13.6229 5.23069 12.146 3.75378 10.3241 3.75378V3.75378C8.50229 3.75378 7.02539 5.23069 7.02539 7.05254V9.06048",
    stroke: "url(#paint1_linear_1389_9565)",
    strokeWidth: 0.787965
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1389_9565)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.4375,
    y: 11.1047,
    width: 15.7767,
    height: 4.58957,
    rx: 1.43424,
    fill: "url(#paint2_linear_1389_9565)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.4769,
    y: 11.1441,
    width: 15.6979,
    height: 4.51078,
    rx: 1.39484,
    stroke: "white",
    strokeWidth: 0.0787965
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66016 12.9767L7.36615 13.9616",
    stroke: "white",
    strokeWidth: 0.461516,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66016 13.9617L7.36615 12.9767",
    stroke: "white",
    strokeWidth: 0.461516,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51367 12.4841L6.51367 14.454",
    stroke: "white",
    strokeWidth: 0.461516,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33594 12.9767L11.0419 13.9616",
    stroke: "white",
    strokeWidth: 0.461516,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33594 13.9617L11.0419 12.9767",
    stroke: "white",
    strokeWidth: 0.461516,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1895 12.4841L10.1895 14.454",
    stroke: "white",
    strokeWidth: 0.461516,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0117 12.9767L14.7177 13.9616",
    stroke: "white",
    strokeWidth: 0.461516,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0117 13.9615L14.7177 12.9766",
    stroke: "white",
    strokeWidth: 0.461516,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8652 12.4841L13.8652 14.454",
    stroke: "white",
    strokeWidth: 0.461516,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1389_9565",
    x: 2.4375,
    y: 11.1047,
    width: 15.7773,
    height: 5.37756,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.787965
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.393983
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1389_9565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1389_9565",
    x1: 5.40013,
    y1: 8.91013,
    x2: 15.8407,
    y2: 17.7747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB86FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1389_9565",
    x1: 10.3241,
    y1: 3.75378,
    x2: 10.3241,
    y2: 9.06048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B19DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3935E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1389_9565",
    x1: 3.36221,
    y1: 11.4607,
    x2: 10.3258,
    y2: 15.6943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A8BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C183FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraCardIcon9);
export default __webpack_public_path__ + "static/media/camera_card_icon9.50eb99921622c007161e7f784f2bf4db.svg";
export { ForwardRef as ReactComponent };